import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

export interface ScrollableProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function Scrollable({ children, sx }: ScrollableProps) {
  return (
    <Box sx={{ position: 'relative', flex: 1, width: '100%', height: '100%', ...sx }}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          overflow: 'auto',
        }}
        tabIndex={0}
      >
        {children}
      </Box>
    </Box>
  );
}
